import React from "react";
import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import { keyframes } from "@emotion/react";

const pulse = keyframes`
  0% { transform: scale(1); opacity: 1; }
  50% { transform: scale(1.2); opacity: 0.6; }
  100% { transform: scale(1); opacity: 1; }
`;

const LoadingScreen = () => {
  const theme = useTheme();

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
      minHeight="60vh"
      sx={{
        backgroundColor: theme.palette.background.default,
        transition: "background-color 0.3s ease",
        padding: 2,
      }}
    >
      <Box
        sx={{
          animation: `${pulse} 1.5s ease-in-out infinite`,
        }}
      >
        <CircularProgress
          thickness={5}
          size={80}
          sx={{
            color: theme.palette.primary.main,
          }}
        />
      </Box>
      <Typography
        variant="h6"
        sx={{
          marginTop: 2,
          color: theme.palette.text.secondary,
          fontWeight: 500,
          textAlign: "center",
        }}
      >
        Loading, please wait...
      </Typography>
    </Box>
  );
};

export default LoadingScreen;
